var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 401.72 226.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-8);}.cls-11{fill:url(#linear-gradient-9);}.cls-12{fill:url(#linear-gradient-10);}.cls-13{fill:#cec4d6;}.cls-14{fill:#e5dfe9;}.cls-15{fill:url(#linear-gradient-11);}.cls-16{fill:url(#linear-gradient-12);}.cls-17{fill:#5c479e;}.cls-18{fill:#aca5b5;}.cls-19{fill:#c0b8cc;}.cls-20{fill:#34254c;}.cls-21{fill:#51347f;}.cls-22{fill:url(#linear-gradient-13);}.cls-23{fill:url(#linear-gradient-14);}.cls-24{fill:url(#linear-gradient-15);}.cls-25{fill:url(#linear-gradient-16);}.cls-26{fill:url(#linear-gradient-17);}.cls-27{fill:url(#linear-gradient-18);}.cls-28{fill:url(#linear-gradient-19);}.cls-29{fill:url(#linear-gradient-20);}.cls-30{fill:url(#linear-gradient-21);}.cls-31{fill:url(#linear-gradient-22);}.cls-32{fill:url(#linear-gradient-23);}.cls-33{fill:url(#linear-gradient-24);}.cls-34{fill:url(#linear-gradient-25);}.cls-35{fill:url(#linear-gradient-26);}.cls-36{fill:#c8b8d3;}.cls-37{fill:url(#linear-gradient-27);}.cls-38{fill:url(#linear-gradient-28);}.cls-39{fill:url(#linear-gradient-29);}.cls-40{fill:url(#linear-gradient-30);}.cls-41{fill:url(#linear-gradient-31);}.cls-42{fill:url(#linear-gradient-32);}.cls-43{fill:url(#linear-gradient-33);}.cls-44{fill:url(#linear-gradient-34);}.cls-45{fill:url(#linear-gradient-35);}.cls-46{fill:#2d2244;}.cls-47{fill:url(#linear-gradient-36);}.cls-48{fill:url(#linear-gradient-37);}.cls-49{fill:url(#linear-gradient-38);}.cls-50{fill:url(#linear-gradient-39);}.cls-51{fill:url(#linear-gradient-40);}.cls-52{fill:url(#linear-gradient-41);}.cls-53{fill:url(#linear-gradient-42);}.cls-54{fill:url(#linear-gradient-43);}.cls-55{fill:url(#linear-gradient-44);}.cls-56{fill:url(#linear-gradient-45);}.cls-57{fill:url(#linear-gradient-46);}.cls-58{fill:url(#linear-gradient-47);}.cls-59{fill:url(#linear-gradient-48);}.cls-60{fill:url(#linear-gradient-49);}.cls-61{fill:url(#linear-gradient-50);}.cls-62{fill:url(#linear-gradient-51);}.cls-63{fill:url(#linear-gradient-52);}.cls-64{fill:url(#linear-gradient-53);}.cls-65{fill:url(#linear-gradient-54);}.cls-66{fill:url(#linear-gradient-55);}.cls-67{fill:url(#linear-gradient-56);}.cls-68{fill:url(#linear-gradient-57);}.cls-69{fill:url(#linear-gradient-58);}.cls-70{fill:url(#linear-gradient-59);}.cls-71{fill:url(#linear-gradient-60);}.cls-72{fill:url(#linear-gradient-61);}.cls-73{fill:url(#linear-gradient-62);}.cls-74{fill:url(#linear-gradient-63);}.cls-75{fill:url(#linear-gradient-64);}.cls-76{fill:url(#linear-gradient-65);}.cls-77{fill:url(#linear-gradient-66);}.cls-78{fill:#988ca5;}.cls-79{fill:url(#linear-gradient-67);}.cls-80{fill:url(#linear-gradient-68);}.cls-81,.cls-82{mix-blend-mode:overlay;}.cls-81{fill:url(#linear-gradient-69);}.cls-82{opacity:0.57;fill:url(#linear-gradient-70);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 181.96,
    y1: 128.92,
    x2: 229.37,
    y2: 128.92,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34254c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51397f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 174.08,
    y1: 183.45,
    x2: 229.2,
    y2: 183.45,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1dae5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f4f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 157.43,
    y1: 157.99,
    x2: 172.94,
    y2: 157.99,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8b8d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8b8d3",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 155.29,
    y1: 172.85,
    x2: 220.52,
    y2: 172.85,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 178.4,
    y1: 222.04,
    x2: 191.79,
    y2: 222.04,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8b8d3",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8b8d3",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 189.68,
    y1: 194.08,
    x2: 230.31,
    y2: 194.08,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 224.93,
    y1: 214.81,
    x2: 242.54,
    y2: 214.81,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 253.16,
    y1: 182.59,
    x2: 237.55,
    y2: 190.79,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 179.98,
    y1: 129.86,
    x2: 190.39,
    y2: 147.12,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 232,
    y1: 121.01,
    x2: 222.85,
    y2: 137.25,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 181.34,
    y1: 171.27,
    x2: 221.36,
    y2: 171.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 188.27,
    y1: 172.52,
    x2: 235.39,
    y2: 170.54,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d2244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2c5e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 185.32,
    y1: 128.89,
    x2: 193.21,
    y2: 154.86,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce1d3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed202e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 219.59,
    y1: 117.18,
    x2: 224.43,
    y2: 139.37,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 192.04,
    y1: 155.88,
    x2: 215.27,
    y2: 154.4,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a193ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cec4d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 208.79,
    y1: 164.43,
    x2: 205.62,
    y2: 139.87,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 193.15,
    y1: 166.97,
    x2: 205.87,
    y2: 155.41,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cec4d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cec4d6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 199.19,
    y1: 161.97,
    x2: 197.51,
    y2: 150.61,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34254c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#432a68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 206.75,
    y1: 160.85,
    x2: 205.07,
    y2: 149.49,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 201.85,
    y1: 157.43,
    x2: 201.02,
    y2: 148.77,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 212.38,
    y1: 151.09,
    x2: 215.32,
    y2: 147.94,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3492b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4cc8e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 213.35,
    y1: 156.05,
    x2: 216.66,
    y2: 156.05,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d733db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f43ef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 213.92,
    y1: 136.92,
    x2: 220.06,
    y2: 135.33,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e45a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2265c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 188.13,
    y1: 141.12,
    x2: 199.7,
    y2: 138.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 190.7,
    y1: 126.35,
    x2: 221.23,
    y2: 126.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 187.04,
    y1: 117.75,
    x2: 183.68,
    y2: 118.59,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 221.25,
    y1: 109.39,
    x2: 224.2,
    y2: 108.78,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 194.58,
    y1: 94.95,
    x2: 204.36,
    y2: 94.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 188.58,
    y1: 113.85,
    x2: 221.7,
    y2: 102.71,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 197.12,
    y1: 123.91,
    x2: 205.33,
    y2: 94.84,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8b8d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8b8d3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 196.55,
    y1: 128.48,
    x2: 213.9,
    y2: 124.17,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 186.27,
    y1: 117.59,
    x2: 226.32,
    y2: 110.44,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#201d21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#524b56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 180.92,
    y1: 116.57,
    x2: 199.64,
    y2: 115.53,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#111011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111011",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 208.45,
    y1: 100.48,
    x2: 213.7,
    y2: 115.93,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ede7f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ede7f2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 215.81,
    y1: 112.45,
    x2: 221.07,
    y2: 119.7,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 226.67,
    y1: 186.9,
    x2: 247.51,
    y2: 186.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 186.92,
    y1: 201.16,
    x2: 165.4,
    y2: 187.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 238.29,
    y1: 153.15,
    x2: 236.08,
    y2: 133.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 173.9,
    y1: 151.16,
    x2: 177.57,
    y2: 151.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 188.35,
    y1: 140.73,
    x2: 199.91,
    y2: 137.9,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 171.79,
    y1: 151.78,
    x2: 153.18,
    y2: 133.33,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 153.15,
    y1: 129.3,
    x2: 158.35,
    y2: 129.3,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 149.17,
    y1: 136.18,
    x2: 154.74,
    y2: 136.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 145.83,
    y1: 145.35,
    x2: 153.94,
    y2: 145.35,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 146.31,
    y1: 153.58,
    x2: 156.29,
    y2: 153.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 165.52,
    y1: 133.13,
    x2: 161.26,
    y2: 148.9,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 177.73,
    y1: 149.09,
    x2: 165.11,
    y2: 140.05,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 169.69,
    y1: 131.18,
    x2: 170.74,
    y2: 125.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 154.47,
    y1: 130.58,
    x2: 158.35,
    y2: 130.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 149.89,
    y1: 136.79,
    x2: 154.7,
    y2: 136.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 150.05,
    y1: 146.65,
    x2: 153.94,
    y2: 146.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 151.53,
    y1: 154.36,
    x2: 156.29,
    y2: 154.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -1804.92,
    y1: 199.49,
    x2: -1823.53,
    y2: 181.04,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -1584.45, 117.01)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -1823.56,
    y1: 177.01,
    x2: -1818.36,
    y2: 177.01,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -1584.45, 117.01)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -1827.54,
    y1: 183.88,
    x2: -1821.97,
    y2: 183.88,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -1584.45, 117.01)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -1830.88,
    y1: 193.06,
    x2: -1822.77,
    y2: 193.06,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -1584.45, 117.01)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -1830.4,
    y1: 201.28,
    x2: -1820.43,
    y2: 201.28,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -1584.45, 117.01)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -1811.19,
    y1: 180.84,
    x2: -1815.45,
    y2: 196.61,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -1584.45, 117.01)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -1798.98,
    y1: 196.79,
    x2: -1811.6,
    y2: 187.75,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -1584.45, 117.01)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -1807.02,
    y1: 178.88,
    x2: -1805.97,
    y2: 173.1,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -1584.45, 117.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -1822.24,
    y1: 178.29,
    x2: -1818.36,
    y2: 178.29,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -1584.45, 117.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -1826.83,
    y1: 184.49,
    x2: -1822.02,
    y2: 184.49,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -1584.45, 117.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -1826.67,
    y1: 194.35,
    x2: -1822.77,
    y2: 194.35,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -1584.45, 117.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -1825.19,
    y1: 202.06,
    x2: -1820.43,
    y2: 202.06,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -1584.45, 117.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 231.51,
    y1: 223.43,
    x2: 268.15,
    y2: 223.43,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 230.52,
    y1: 247.92,
    x2: 273.1,
    y2: 212.44,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbaec4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ded1e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -2796.51,
    y1: 1150.08,
    x2: -2759.87,
    y2: 1150.08,
    gradientTransform: "matrix(-0.82, 0.57, 0.57, 0.82, -2772.32, 852.14)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 142.07,
    y1: 249.25,
    x2: 192.16,
    y2: 242.15,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 260.51,
    y1: 149.14,
    x2: 156.32,
    y2: 221.12,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04074a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 251.13,
    y1: 145.53,
    x2: 147.7,
    y2: 242.52,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -17.63, -29.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04074a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04074a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.56,36.1H35.88V66.48a32,32,0,0,1,12.33-7.93,47.06,47.06,0,0,1,17.17-3.08q16.52,0,27.4,7.48a44,44,0,0,1,16,19.38,64.89,64.89,0,0,1,5.06,25.75q0,25.76-14.53,40.83T58.34,164q-17.62,0-30.61-6.06a46.8,46.8,0,0,1-20-16.83A48.77,48.77,0,0,1,0,116.22H36.76a19.8,19.8,0,0,0,6.39,11.34q5.06,4.51,13.86,4.51,10.35,0,15.41-6.6t5.06-17.61q0-10.78-5.28-16.51T56.79,85.63q-7.49,0-12.32,3.63a16.94,16.94,0,0,0-6.39,9.57H1.76V3.08h102.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.13,21.79Q163.77,0,196.34,0t47.22,21.79q14.64,21.8,14.64,59.65,0,38.31-14.64,60.1t-47.22,21.79q-32.57,0-47.21-21.79t-14.64-60.1Q134.49,43.58,149.13,21.79Zm67.25,25.42q-4.84-12-20-12t-20,12q-4.83,12-4.84,34.23a144.39,144.39,0,0,0,1.76,24.77q1.77,9.8,7.16,15.85t16,6.05q10.57,0,16-6.05t7.16-15.85a144.39,144.39,0,0,0,1.76-24.77Q221.22,59.21,216.38,47.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.65,21.79Q307.29,0,339.86,0t47.22,21.79q14.64,21.8,14.64,59.65,0,38.31-14.64,60.1t-47.22,21.79q-32.57,0-47.21-21.79T278,81.44Q278,43.58,292.65,21.79ZM359.9,47.21q-4.84-12-20-12t-20,12Q315,59.22,315,81.44a144.39,144.39,0,0,0,1.76,24.77q1.75,9.8,7.16,15.85t15.95,6.05q10.58,0,16-6.05T363,106.21a144.39,144.39,0,0,0,1.76-24.77Q364.74,59.21,359.9,47.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.7,96.12S172,88,172.89,86.81s12.71-6.32,27.81-9.52,15.82-2,17-1.13,2.59,10.1,2.56,12S174.7,96.12,174.7,96.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M246.26,157.91l-1,2.31-7.33,16.15-7,15.47c-3.48-2.45-4.57-11.39-4.4-18.2a54.55,54.55,0,0,0-.77-11.32,15,15,0,0,1-5.14-4.55,26,26,0,0,1-2.07-3.21h0c-.45-.82-.68-1.35-.68-1.35-8.19.4-13.77-4.91-15.1-5.77s-3.79-.05-6.26,5.49c-2.22,5-7.85,7-8.95,7.36l-.19.06c-.24,1.34-.49,2.55-.75,3.64-2.09,8.83-4.64,10-4.64,10-.28,2.86,1.43,7,2,12.35a106.62,106.62,0,0,1,0,13.59l-7.37-4.57-14.42-9s-5.46-12.9-5.12-17.19a12,12,0,0,1,.73-3.26,15.55,15.55,0,0,1,1.39-2.83h0a12,12,0,0,1,1-1.4s0-.68,0-1.76c0-.48,0-1,.08-1.65a33.63,33.63,0,0,1,.62-4.54,10.39,10.39,0,0,1,.33-1.16,13.78,13.78,0,0,1,.84-1.9,14,14,0,0,1,1-1.56h0l0,0,0,0v0h0l0-.05a.44.44,0,0,1,.08-.11.76.76,0,0,1,.08-.11l.28-.35a11.47,11.47,0,0,1,1.11-1.23h0s.33-1.13.77-2.75c.34-1.25.74-2.79,1.12-4.34.87-3.53.78-4.79,3-6.52s2.77-3.15,4.07-4.18h0l.06-.05c.76-.58,2.14-1.46,3.21-2.11h0l1.47-.89a14.09,14.09,0,0,1,.79-4.63,6.25,6.25,0,0,1-.64-1.5c-.21-.67-.34-1.28-.34-1.28-.37.25-.73.47-1.08.67h0c-3.82,2.17-6.53,1.43-6.53,1.43a14.88,14.88,0,0,1-3,.91,13.84,13.84,0,0,1-3.87.19,18.75,18.75,0,0,1-10.79-5.27l3.33-4.71,7.34-10.4a8.64,8.64,0,0,1,2.93,1h0a6.8,6.8,0,0,1,.6.42h0l.26.23a3.2,3.2,0,0,1,.62.78h0l0,.05h0a6.32,6.32,0,0,1,.1-.67,4.41,4.41,0,0,1,.43-1.26,1.28,1.28,0,0,1,.11-.2,2.88,2.88,0,0,1,.68-.76,2.07,2.07,0,0,1,.83-.4c0-.21,0-.42.07-.62,1.05-7.67,6-7.85,6-7.85,1-5.76,6.87-5.85,6.87-5.85s1.24.29,3.18.57h0a39.93,39.93,0,0,0,12.64-.07,17.45,17.45,0,0,0,9.71-5.39,11,11,0,0,0,1.05-1.35c4.83-1.12,8.56,5,8.56,5,2.76,0,5,1.85,6.25,3.22a12,12,0,0,1,1.18,1.49l.1-.12a8,8,0,0,1,1-1.06h0l0,0h0l.19-.16h0a10,10,0,0,1,1.79-1.11,10.92,10.92,0,0,1,2.79-.93l6.5,13.47,1.41,2.91a10.07,10.07,0,0,1-5.33,6.51,12.08,12.08,0,0,1-1.3.58,9,9,0,0,1-1,.3c-3.66.85-7.67-.78-10-2h0l-.09,0-.05,0-.15-.08c-1-.53-1.57-.93-1.57-.93a12.46,12.46,0,0,1,.54,2h0c0,.13.05.26.07.39a23.18,23.18,0,0,1,.11,6,19.19,19.19,0,0,1,1.13,4.56,4.42,4.42,0,0,1-.41,2.92s0,0,0,.06a1.77,1.77,0,0,1,.36-.2h0a6.9,6.9,0,0,1,1.28-.43l.26-.06h0c.32-.06.67-.11,1.07-.15h0a13.67,13.67,0,0,1,5.63.83h0l.17.07.34.12c6,2.28,8.56,11.9,8.56,11.9a10.53,10.53,0,0,1,2.66,2.81,17.78,17.78,0,0,1,3.16,8.34C245.55,152.11,246.26,157.91,246.26,157.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M163.68,122.13a18.75,18.75,0,0,1-10.79-5.27l3.33-4.71a13.66,13.66,0,0,0,7.12,4.94,10.41,10.41,0,0,0,3.32.3A16.47,16.47,0,0,1,163.68,122.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217.77,122.55l-5,7.59s-4.42,7.12-12.68,6.42-15.74-8.25-21.67-4.84S169,142.79,169,142.79l3.41-1s-6,4-7.06,6.47a1.14,1.14,0,0,0,.17,1.43L162,150.72a14,14,0,0,1,1-1.56h0l0,0,0,0v0h0l0-.05a.44.44,0,0,1,.08-.11.76.76,0,0,1,.08-.11l.28-.35a11.47,11.47,0,0,1,1.11-1.23h0s.33-1.13.77-2.75c.34-1.25.74-2.79,1.12-4.34.87-3.53.78-4.79,3-6.52s2.77-3.15,4.07-4.18h0l.06-.05c.76-.58,2.14-1.46,3.21-2.11h0l1.47-.89a14.09,14.09,0,0,1,.79-4.63,6.25,6.25,0,0,1-.64-1.5c-.21-.67-.34-1.28-.34-1.28-.37.25-.73.47-1.08.67h0c-3.82,2.17-6.53,1.43-6.53,1.43a14.88,14.88,0,0,1-3,.91,17.79,17.79,0,0,0,1.84-5.18,7.54,7.54,0,0,0,2.07-1.17,4.11,4.11,0,0,0,3.56,1.18c2.51-.17,7.42-2.4,7.39-5.09a17.69,17.69,0,0,0,12.05,12.14C204.48,126.93,213.61,124.1,217.77,122.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M181.92,174c-.28,2.86,1.43,7,2,12.35a106.62,106.62,0,0,1,0,13.59l-7.37-4.57c1.71-4.69-.51-11.76-.74-17-.28-6.46,3.65-6.73,3.65-6.73a10.88,10.88,0,0,1,3.37-12.1,22.37,22.37,0,0,1,3.8,4.45C184.47,172.82,181.92,174,181.92,174Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M221.59,147.32a25.77,25.77,0,0,0-3.1,7.24c-.45-.82-.68-1.35-.68-1.35-8.19.4-13.77-4.91-15.1-5.77s-3.79-.05-6.26,5.49c-2.22,5-7.85,7-8.95,7.36-.47-.6-1.25-1.58-2.29-2.72,1.94-1.92,3.55-4.65,6.21-8.88a14.48,14.48,0,0,1,10-7c3.43-.71,5,1.4,12.82,4.81A12.15,12.15,0,0,0,221.59,147.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M237.89,176.37l-7,15.47c-3.48-2.45-4.57-11.39-4.4-18.2a54.55,54.55,0,0,0-.77-11.32,15,15,0,0,1-5.14-4.55,60.8,60.8,0,0,1,6.69-10.84c-1.12,4.56,1.09,8.09,3.7,11.23a45.83,45.83,0,0,0,.58,13.08C232.41,175.19,235.7,176.17,237.89,176.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M246.26,157.91l-1,2.31c-2-2.21-3.7-6.88-4.61-13.31-1.23-8.76-6.63-10-6.63-10,2.14-7-2.75-12.65-3.69-13.64l.34.12c6,2.28,8.56,11.9,8.56,11.9a10.53,10.53,0,0,1,2.66,2.81,17.78,17.78,0,0,1,3.16,8.34C245.55,152.11,246.26,157.91,246.26,157.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M179.94,91.62c.53,3.13,5.75,3.24,5.75,3.24-3.25,1-5.95.73-9.31.16s-5.64,5.45-4.73,5.84,1.78,2,1.78,2c-2.61-1.24-3,0-2.18,2.84a24.18,24.18,0,0,1,.49,7.08c-.52-2.9-2.42-6.82-3.64-9.13a4.41,4.41,0,0,1,.43-1.26,1.28,1.28,0,0,1,.11-.2,2.88,2.88,0,0,1,.68-.76,2.07,2.07,0,0,1,.83-.4c0-.21,0-.42.07-.62,1.05-7.67,6-7.85,6-7.85,1-5.76,6.87-5.85,6.87-5.85s1.24.29,3.18.57C183.87,86.92,179.41,88.5,179.94,91.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M225.77,90l-.12.6a10.59,10.59,0,0,0-8.37-3.07c-.61,2.73-5.32,3.21-5.32,3.21s3.66-2,3.19-4.33-6.47-4.46-6.47-4.46a.58.58,0,0,1-.05-.14,11,11,0,0,0,1.05-1.35c4.83-1.12,8.56,5,8.56,5,2.76,0,5,1.85,6.25,3.22a12,12,0,0,1,1.18,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M164,154.05c-.11.26-3.69,8.88-6.29,11.91h0a15.55,15.55,0,0,1,1.39-2.83h0a12,12,0,0,1,1-1.4s0-.68,0-1.76c0-.48,0-1,.08-1.65A12.18,12.18,0,0,0,164,154.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M229.21,106a26.63,26.63,0,0,0,2.67,4.47c-3.66.85-7.67-.78-10-2h0l-.09,0-.05,0-.15-.08c-1-.53-1.57-.93-1.57-.93a12.46,12.46,0,0,1,.54,2h0c0,.13.05.26.07.39-4.7-6.52-6.78-15.08-6.88-15.49.14.41,3.15,8.85,10.4,11.13A13,13,0,0,0,229.21,106Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M239.52,103.05a10.07,10.07,0,0,1-5.33,6.51,24.79,24.79,0,0,1-2.51-4.11,12.76,12.76,0,0,0,6.43-5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M223.12,122.61h0s-6.71,3.77-7.79,5-2,3-7.17,4.63a35.69,35.69,0,0,1-4.36,1c-4.49.76-10.08.79-14.66-1.79a13.07,13.07,0,0,0-5.86-4.86,45.9,45.9,0,0,0,6.06.94l.57,0c.31,0,.6,0,.86,0a2.94,2.94,0,0,1,1-.86,15.93,15.93,0,0,1,3.8-.22h.73c1.07,0,2.26-.06,3.5-.16s2.17-.22,3.14-.35l.73-.1c1.73-.25,3-.49,3.34-.51a2.65,2.65,0,0,1,1.81.68l.14.13.48-.17c.58-.21,1.63-.6,2.91-1.1l.54-.22,1.15-.46.4-.17h0c1-.4,2-.85,3-1.3l.31-.15a28.62,28.62,0,0,0,4.13-2.31c0,.24,0,.46,0,.66a3.85,3.85,0,0,1-.45,2.26s0,0,0,.06a1.77,1.77,0,0,1,.36-.2h0A6.9,6.9,0,0,1,223.12,122.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M222,120.93c-1.65,1-7.62,4.53-12.41,5.74l-.08,2.11c0-.23-.06-2.63-5-1.85a76.09,76.09,0,0,1-10.22.86s1.39,6.11,9.54,5.46c-4.49.76-10.08.79-14.66-1.79a13.07,13.07,0,0,0-5.86-4.86,45.9,45.9,0,0,0,6.06.94l.57,0c.31,0,.6,0,.86,0a2.94,2.94,0,0,1,1-.86,15.93,15.93,0,0,1,3.8-.22h.73c1.07,0,2.26-.06,3.5-.16s2.17-.22,3.14-.35l.73-.1c1.73-.25,3-.49,3.34-.51a2.65,2.65,0,0,1,1.81.68l.14.13.48-.17c.58-.21,1.63-.6,2.91-1.1l.54-.22,1.15-.46.4-.17h0c1-.4,2-.85,3-1.3l.31-.15a28.62,28.62,0,0,0,4.13-2.31C221.93,120.51,221.94,120.73,222,120.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M196.35,126.46V133l-.74-6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M203.72,125.85l-.28,6.69L203,126Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M189.91,127.57l-.38,2.75-.19-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M209.17,130.88c0-1.9-.2-3.87-.3-4.86l.14.13.48-.17A19.38,19.38,0,0,1,209.17,130.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M212.94,124.66l-.28,4.09-.26-3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M214.49,124l-.2,3-.2-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M217.78,122.58l-.16,2.35-.15-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M194,133.81c-3.41,1-7.43-6.92-14-6.31a21.64,21.64,0,0,0-6.42,1.9l.06-.05c.76-.58,2.14-1.46,3.21-2.11h0a12.83,12.83,0,0,1,5.75-.7C187.39,126.78,190.69,133.41,194,133.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M230.11,123.22c-9.28-1.16-18.06,8.1-18.06,8.1,3.82-4.95,7.19-7.15,9.45-8.13l.32-.14h0a11.84,11.84,0,0,1,1.54-.49h0a5,5,0,0,1,1.07-.15h0A13.67,13.67,0,0,1,230.11,123.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "162.93 149.16 162.93 149.16 162.93 149.16 162.93 149.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M172.45,141.77a24.48,24.48,0,0,0-9.48,7.34,13.62,13.62,0,0,1,1.63-1.91s.33-1.13.77-2.75A36.27,36.27,0,0,1,172.45,141.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M162,158a18.53,18.53,0,0,1-3,5.16,12,12,0,0,1,1-1.4s0-.68,0-1.76A6.55,6.55,0,0,0,162,158Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M226.8,88.9c-.36.33-3.33,3.33-2.42,12.33,0,0-1.9-6.74.11-12.64a12,12,0,0,1,1.18,1.49A8,8,0,0,1,226.8,88.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M226.82,88.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M168,104.24a7.29,7.29,0,0,0-.88-1A3.26,3.26,0,0,1,168,104.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M171.74,112.73c-1.44-4.64-2.77-7.13-3.74-8.45h0a5.13,5.13,0,0,1,.53-1.93A35.08,35.08,0,0,1,171.74,112.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M173.4,102.34a4.17,4.17,0,0,0-4.08-1,2.07,2.07,0,0,1,.83-.4c0-.21,0-.42.07-.62A5,5,0,0,1,173.4,102.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M182.53,115.79a39.76,39.76,0,0,1-4,4.42c-.21-.67-.34-1.28-.34-1.28C177.8,119.18,182.53,115.79,182.53,115.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M220.06,107.38a12.46,12.46,0,0,1,.54,2,14.72,14.72,0,0,1-2.85-5.19,10.28,10.28,0,0,0,3.88,4.17C220.65,107.78,220.06,107.38,220.06,107.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M187.12,119.31l1.5,2.22c-2.4,1.91-6.66,4.41-9,4.73s-3.79-.06-4.05-1.46c-.19-1.07,1.7-2.9,2.62-3.72.29-.26.48-.41.48-.41l.49,1s-2.78,2.86-.91,3.2l.19,0c2.23.18,8.61-5.82,8.61-5.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M178.24,124.91h0s-1.7.14-1.63-1.13a6.47,6.47,0,0,1,1.58-2.7c.29-.26.48-.41.48-.41l.49,1S176.37,124.57,178.24,124.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M225.79,117a7,7,0,0,1-2.41,2c-3,1.69-9.15.3-9.15.3l-.7-3.27a16.92,16.92,0,0,0,7.87,1.84,7.26,7.26,0,0,0,2.1-.41c1.36-.5,1.6-1.33,1.23-1.88-.53-.75-3.92-.16-3.92-.16l.08-2.74a15.68,15.68,0,0,1,3,.49,3.34,3.34,0,0,1,1.88,1.08A2.3,2.3,0,0,1,225.79,117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M225.79,117a3.35,3.35,0,0,1-2.29.43c2.58-.77,1-3.35.36-4.29a3.34,3.34,0,0,1,1.88,1.08A2.3,2.3,0,0,1,225.79,117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M181.23,84.07s-4.67,2.09-4.12,12.48,9.14,15.82,9.14,15.82l.15,2.2s-6.62-2.07-10.35-10.51-.82-18.92,5-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M209.46,77s6,2.28,8.6,10.48S216,101.33,211.36,105l1.5,3.53s8.2-5,9-13.73-5.26-16.87-11.34-20.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M214.49,120.72c0,.47-4.16,1.19-5.76,1.48a176.41,176.41,0,0,1-19.8,2.47.53.53,0,0,1-.54-.36,93.46,93.46,0,0,1-3.51-16.13c-.2-1.63-.37-3.26-.5-4.91a1.09,1.09,0,0,1,.78-1.13,95.41,95.41,0,0,1,26-3.86,1.08,1.08,0,0,1,1.06.85C213.62,105.43,214.72,117.23,214.49,120.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M214.23,119.31c0,.48-4.16,1.19-5.76,1.49a178.59,178.59,0,0,1-19.79,2.47.53.53,0,0,1-.54-.37,91.43,91.43,0,0,1-3.51-16.13c-.21-1.62-.38-3.26-.51-4.9a1.08,1.08,0,0,1,.79-1.13,95.76,95.76,0,0,1,26-3.87,1.09,1.09,0,0,1,1.06.86C213.37,104,214.47,115.82,214.23,119.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M208.47,120.8A176.09,176.09,0,0,1,189,123.25a.86.86,0,0,1-.89-.61,91.34,91.34,0,0,1-3.43-15.87C188.06,112.71,195.61,122.15,208.47,120.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M187.82,105.15s1.42,9.23,2.88,14.5l1.88-.28s-1.58-9.22-2-14.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M195.45,103.52s1.32,10,2.59,14.84l2.2-.3s-1.59-9.38-2-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M192.11,105.49s.39,3.45.87,5.79l1.87-.29L194,105.2A12.09,12.09,0,0,0,192.11,105.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M208,104.8a1.66,1.66,0,1,1-1.77-1.54A1.66,1.66,0,0,1,208,104.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M209.14,111.84a1.66,1.66,0,1,1-1.77-1.54A1.66,1.66,0,0,1,209.14,111.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M212.48,91.38a3.39,3.39,0,1,1-3.61-3.16A3.39,3.39,0,0,1,212.48,91.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M183.57,99.79c1.54-.35,5.31-1.11,9.42-2a1,1,0,0,0,.79-1.33L193,93.86a.8.8,0,0,0-.91-.63c-1.86.31-6.67.63-9.64,1.62-.37.12-.77.21-.55,1.42a23.28,23.28,0,0,0,.72,3A.8.8,0,0,0,183.57,99.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M181.23,84.07a16.05,16.05,0,0,0,1.61,3.72s16.15,7.43,28.74-7.34a19.94,19.94,0,0,0-1.92-4.93S202.11,88,181.23,84.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M175.09,69.19s-3.19,1.8-3.65,2.14c-1,.75,2.86,11.52,4.27,11.57a19.24,19.24,0,0,0,3.72-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M174.05,72.42a.63.63,0,0,1-.59.67.61.61,0,0,1-.67-.58.62.62,0,0,1,.58-.67A.63.63,0,0,1,174.05,72.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M207.54,58.84s3.64-.46,4.21-.46c1.24,0,4.6,10.94,3.49,11.83a19.2,19.2,0,0,1-3.58,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M210.31,60.81a.64.64,0,0,0,.88.19.63.63,0,1,0-.88-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M183.37,54.14l-.38-1.3A14.7,14.7,0,0,1,192,50l.75,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M212.06,73.62l-7.9,2.55-23.8,7.68c-9.22-10-7-26.23,5.14-31.18.57-.23,1.13-.43,1.69-.6h0C200.58,47.85,213.15,58.38,212.06,73.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M204.16,76.17l-23.8,7.68c-9.22-10-7-26.23,5.14-31.18.57-.23,1.13-.43,1.69-.6-8.15,3.38-8.87,8.84-1.59,6.6a24.52,24.52,0,0,1,12.5-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M212.06,73.62A19.5,19.5,0,0,1,197.75,86.3c-11.51,2.68-17.39-2.45-17.39-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M212.06,73.62a24.08,24.08,0,0,1-6.87,7c-5.1,3.49-13.2,6.38-24.83,3.23-5.06-9.51-2.13-19.12,5-23.7a17.2,17.2,0,0,1,1.68-.94C195.88,54.9,209.12,58.33,212.06,73.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M205.19,80.62c-5.1,3.49-13.2,6.38-24.83,3.23-5.06-9.51-2.13-19.12,5-23.7-.91,2.24-2.11,6.75-1.11,13.63,1.49,10.33,8.64,13.42,20.92,6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M192,59.19s9.86-1.69,15.36,7.38a1.61,1.61,0,0,1-.44,2.15h0a1.61,1.61,0,0,1-2.33-.52A18.63,18.63,0,0,0,192,59.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M208.94,70.78a1.26,1.26,0,1,1-1.73-.46A1.27,1.27,0,0,1,208.94,70.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M229.3,144.45a18.72,18.72,0,0,1-2.05,2.48h0a60.8,60.8,0,0,0-6.69,10.84,26,26,0,0,1-2.07-3.21h0a25.77,25.77,0,0,1,3.1-7.24A28.78,28.78,0,0,0,229.3,144.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M241.85,138.12a23.22,23.22,0,0,0-14.6,8.81,13.51,13.51,0,0,0,1.76-2.15,30,30,0,0,1-7.42,2.54,29.67,29.67,0,0,1,3-4c5.42-6.22,14.63-8,14.63-8A10.53,10.53,0,0,1,241.85,138.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M187.5,160.29l-.19.06c-.24,1.34-.49,2.55-.75,3.64a22.37,22.37,0,0,0-3.8-4.45c.22-.19.45-.35.67-.51a12.34,12.34,0,0,0,1.78-1.46C186.25,158.71,187,159.69,187.5,160.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M185.21,157.57a12.34,12.34,0,0,1-1.78,1.46c-.22.16-.45.32-.67.51a32.75,32.75,0,0,0-6.24-4.46,21.41,21.41,0,0,0-15.41-2.46,13.78,13.78,0,0,1,.84-1.9,14,14,0,0,1,1-1.56h0l0,0,0,0v0h0l0-.05a.44.44,0,0,1,.08-.11.76.76,0,0,1,.08-.11l.28-.35c.55-.08,1.19-.16,1.9-.2a20.9,20.9,0,0,1,10.15,1.7A32.32,32.32,0,0,1,185.21,157.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M234.19,109.56a12.08,12.08,0,0,1-1.3.58,9,9,0,0,1-1,.3,26.63,26.63,0,0,1-2.67-4.47,10.5,10.5,0,0,0,2.47-.52A24.79,24.79,0,0,0,234.19,109.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M231.68,105.45a10.5,10.5,0,0,1-2.47.52A29.36,29.36,0,0,1,227,88.71h0a10,10,0,0,1,1.79-1.11,31.39,31.39,0,0,0,1.67,15.11C230.87,103.72,231.28,104.63,231.68,105.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M169.39,116.76a17.79,17.79,0,0,1-1.84,5.18,13.84,13.84,0,0,1-3.87.19,16.47,16.47,0,0,0,3-4.74A9.72,9.72,0,0,0,169.39,116.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M169.39,116.76a9.72,9.72,0,0,1-2.73.63c2.31-5.64,1.26-11.61.7-13.93a3.2,3.2,0,0,1,.62.78h0l0,.05h0a5.13,5.13,0,0,1,.53-1.93,1.28,1.28,0,0,1,.11-.2C170.2,108.55,170.07,113.35,169.39,116.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M183.68,99.15c1.55-.35,5.48-1.25,9.42-2a.8.8,0,0,0,.63-1l-.62-3a.8.8,0,0,0-.91-.63,75.29,75.29,0,0,0-9.66,2.15.79.79,0,0,0-.53.89,20.56,20.56,0,0,0,.73,3A.79.79,0,0,0,183.68,99.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M158.51,115.84a12.53,12.53,0,0,1-4.49.87,12.08,12.08,0,0,1-5.33-1.15,1.5,1.5,0,0,1-.61.56h0a6.56,6.56,0,0,1-4,.4c-4-.52-5.4-2.64-5.35-4.22a1.29,1.29,0,0,1,.68-1h0a8.82,8.82,0,0,1,3.61-.82c1.1-.07,1.39-.41.87-1.16l-.09-.11c-.67-.65-2.87-.68-4.12-1.35a4.51,4.51,0,0,1-2-4.13c0-.85.79-1.34,1.83-1.5a6.56,6.56,0,0,1,3.48.51c2.12,1,2.88.59,3-.52.06-.79-1.57-1.86-3.06-2.88-.61-.43-1.2-.84-1.64-1.22-1.51-1.32-.6-4.07,2.06-4.57a2,2,0,0,1,.78,0h0c2.07.4,3,4,4.2,3.45s.35-1.76-1.52-3.69a9.94,9.94,0,0,1-.74-.82c-1.63-1.93-3.05-4.56-1.22-5.92a1.86,1.86,0,0,1,1.51-.29c2.32.42,5.63,3.91,7.56,8.21a19.55,19.55,0,0,0,1.67,3.13c.73,1,1.07.9,1.2.74a.7.7,0,0,0,.08-.12c.5-.75.81-5.51,1.07-8.53,0-.49.1-1,.18-1.42.37-2.33,1.15-4.1,2.58-4.46a3.19,3.19,0,0,1,.71-.1c1.25,0,1.91,1,2.2,3.38a9.14,9.14,0,0,1,.06,1.72c-.13,2-.81,3.87-.78,6.23.05,3,1.85,6.2,2.43,10.11S163.9,113.74,158.51,115.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M149.21,90.71c-.2,1.7-2,1.83-3.25,1.72-.18-.21-.36-.43-.53-.65-1.38-1.84-2.32-4-.69-5.27a1.86,1.86,0,0,1,1.51-.29c.5.61,1.52,1.38,2.23,2.32A3,3,0,0,1,149.21,90.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M146,97.1a2.8,2.8,0,0,1-3.19,2.18c-.51-.36-1-.71-1.42-1l-.22-.18c-1.51-1.32-.6-4.07,2.06-4.57a2,2,0,0,1,.78,0h0a12.78,12.78,0,0,1,1.54,2h0A2.29,2.29,0,0,1,146,97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M144.63,109.2a2.55,2.55,0,0,1-.88,0l-1.47-.36a11.67,11.67,0,0,1-2.65-1,4.51,4.51,0,0,1-2-4.13c0-.85.79-1.34,1.83-1.5a11.37,11.37,0,0,0,2.94,2,9.51,9.51,0,0,1,.9.37c1.22.55,2.41,1.33,2.59,2.08C146.09,107.52,146,109,144.63,109.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M148.08,116.12h0a6,6,0,0,1-3.49.46l-.56-.06c-4-.52-5.4-2.64-5.35-4.22a1.29,1.29,0,0,1,.68-1h0c.09,0,1.69-.63,5.47,1l.33.14C148.79,113.89,149.67,115,148.08,116.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M154.15,108.63c-.1-.2-3.11-6,1.33-11.07.73,1,1.07.9,1.2.74l.1.19S152.6,104.47,154.15,108.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M158.51,115.84a12.53,12.53,0,0,1-4.49.87c9.69-2.21,8.46-11.28,7.31-14.1a17.5,17.5,0,0,1,.09-12.49c1.28-3.46.42-5.57-.12-6.45,1.25,0,1.91,1,2.2,3.38a9.14,9.14,0,0,1,.06,1.72c-.13,2-.81,3.87-.78,6.23.05,3,1.85,6.2,2.43,10.11S163.9,113.74,158.51,115.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M163.56,88.77a5.59,5.59,0,0,1-5.55-.54c.37-2.33,1.15-4.1,2.58-4.46,1.71-.43,2.56.46,2.91,3.28A9.14,9.14,0,0,1,163.56,88.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M149.21,90.71c-.2,1.7-3.38,2.53-3.78,1.07.32-3.13,2.1-3.36,3-3.24A3,3,0,0,1,149.21,90.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M146,97.1c-.07,2.52-3.68,2.85-4.61,1.14a2.6,2.6,0,0,1,.4-2.6c1.57-2,3.67-.25,3.76-.18h0A3,3,0,0,1,146,97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M144.63,109.2a2.55,2.55,0,0,1-.88,0l-1.47-.36a4.24,4.24,0,0,1,1-4.28c1.22.55,2.41,1.33,2.59,2.08C146.09,107.52,146,109,144.63,109.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M148.08,116.12h0a6,6,0,0,1-3.49.46,3.33,3.33,0,0,1-.42-2.6,3,3,0,0,1,1-1.65C148.79,113.89,149.67,115,148.08,116.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M237.77,104.92a12.34,12.34,0,0,0,4.58,0,12,12,0,0,0,5-2.11,1.47,1.47,0,0,0,.7.43h0a6.6,6.6,0,0,0,4.06-.37c3.82-1.25,4.81-3.59,4.47-5.14a1.31,1.31,0,0,0-.86-.9h0a8.72,8.72,0,0,0-3.7-.14c-1.1.13-1.45-.14-1.07-1a.37.37,0,0,1,.07-.12c.53-.77,2.69-1.2,3.79-2.09a4.52,4.52,0,0,0,1.22-4.43c-.18-.84-1-1.18-2.07-1.14a6.48,6.48,0,0,0-3.33,1.15c-1.9,1.33-2.73,1.12-3,0-.21-.77,1.2-2.12,2.47-3.41a19.92,19.92,0,0,0,1.39-1.5c1.24-1.58-.18-4.11-2.88-4.1a2.06,2.06,0,0,0-.76.14h0c-2,.78-2.16,4.44-3.47,4.18-1.47-.31-.68-1.67.8-3.91.19-.3.39-.61.58-1,1.24-2.2,2.14-5,.09-6a1.87,1.87,0,0,0-1.54,0c-2.2.84-4.8,4.89-5.9,9.47a20.18,20.18,0,0,1-1.06,3.39c-.52,1.15-.88,1.08-1,1a.78.78,0,0,1-.1-.1c-.63-.64-1.82-5.26-2.64-8.18-.14-.48-.28-.93-.43-1.36-.81-2.23-1.9-3.82-3.38-3.91a4,4,0,0,0-.71,0c-1.23.21-1.69,1.32-1.54,3.74a9.78,9.78,0,0,0,.27,1.69c.5,2,1.52,3.66,1.92,6,.51,3-.66,6.43-.5,10.38S232.09,103.85,237.77,104.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M242.24,78.5c.51,1.63,2.35,1.41,3.52,1.08.13-.24.27-.48.39-.74,1-2.06,1.53-4.41-.3-5.3a1.87,1.87,0,0,0-1.54,0c-.38.7-1.24,1.65-1.75,2.69A3,3,0,0,0,242.24,78.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M246.57,84.17a2.79,2.79,0,0,0,3.54,1.55c.44-.44.87-.88,1.2-1.28.07-.07.13-.15.19-.22,1.24-1.58-.18-4.11-2.88-4.1a2.06,2.06,0,0,0-.76.14h0a12.9,12.9,0,0,0-1.14,2.22h0A2.26,2.26,0,0,0,246.57,84.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M250.18,95.81a2.9,2.9,0,0,0,.86-.21l1.37-.63a12.16,12.16,0,0,0,2.42-1.46,4.52,4.52,0,0,0,1.22-4.43c-.18-.84-1-1.18-2.07-1.14a11.75,11.75,0,0,1-2.54,2.48,9.21,9.21,0,0,0-.8.53c-1.1.77-2.13,1.76-2.17,2.52C248.43,94.43,248.76,95.82,250.18,95.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M248.07,103.25h0a6.07,6.07,0,0,0,3.52-.2c.17,0,.35-.1.54-.17,3.82-1.25,4.81-3.59,4.47-5.14a1.31,1.31,0,0,0-.86-.9h0c-.1,0-1.78-.31-5.2,2l-.3.2C247,101.19,246.3,102.42,248.07,103.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M240.72,97c.06-.21,1.94-6.49-3.37-10.63-.52,1.15-.88,1.08-1,1l-.06.21S241.46,92.64,240.72,97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M237.77,104.92a12.34,12.34,0,0,0,4.58,0c-9.93-.36-10.42-9.51-9.8-12.49a17.52,17.52,0,0,0-2.42-12.26c-1.89-3.16-1.45-5.39-1.08-6.36-1.23.21-1.69,1.32-1.54,3.74a9.78,9.78,0,0,0,.27,1.69c.5,2,1.52,3.66,1.92,6,.51,3-.66,6.43-.5,10.38S232.09,103.85,237.77,104.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M227.78,79.25a5.61,5.61,0,0,0,5.36-1.55c-.81-2.23-1.9-3.82-3.38-3.91-1.76-.1-2.43.93-2.25,3.77A9.78,9.78,0,0,0,227.78,79.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M242.24,78.5c.51,1.63,3.79,1.85,3.91.34-.9-3-2.68-2.91-3.59-2.62A3,3,0,0,0,242.24,78.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M246.57,84.17c.54,2.47,4.14,2.13,4.74.27a2.57,2.57,0,0,0-.88-2.48c-1.9-1.63-3.65.44-3.72.52h0A3,3,0,0,0,246.57,84.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M250.18,95.81a2.9,2.9,0,0,0,.86-.21l1.37-.63a4.25,4.25,0,0,0-1.77-4c-1.1.77-2.13,1.76-2.17,2.52C248.43,94.43,248.76,95.82,250.18,95.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M248.07,103.25h0a6.07,6.07,0,0,0,3.52-.2,3.35,3.35,0,0,0-.07-2.63A2.91,2.91,0,0,0,250.24,99C247,101.19,246.3,102.42,248.07,103.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M229.52,192.38s-1.37-4.55-1.06-6.94,14-35.73,31.87-35.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M233.75,203.89s-4-3.18-4.36-13.68,21-47,34-39.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M266.76,163.9c0,.43,0,.86,0,1.31a64.74,64.74,0,0,1-.66,7c-.06.42-.13.84-.2,1.26-.35,2.18-.83,4.46-1.43,6.82-.11.4-.21.81-.32,1.22a83.87,83.87,0,0,1-2.67,8.09c-.15.39-.3.78-.46,1.18-.95,2.33-2,4.7-3.24,7.09-.19.38-.39.76-.59,1.14-1.09,2-2.28,4.1-3.59,6.15l-.33.51h0l-.81.45c-9.47,5-20.88-1.49-20.92-6.25v-.15a9.35,9.35,0,0,1,.17-1.27c.27-1.51.85-3.89,1.66-6.75l.35-1.21c.67-2.26,1.46-4.77,2.35-7.36l.41-1.19c.94-2.67,2-5.38,3.05-8l.49-1.17c1-2.26,2-4.41,3-6.33l.63-1.13c.25-.44.5-.86.76-1.27a52.31,52.31,0,0,1,3.29-4.74c.28-.36.57-.72.85-1.06a31.66,31.66,0,0,1,6.51-6.09,16.35,16.35,0,0,1,1.45-.87c2.6-1.41,5-1.78,6.87-1,.93.37,1.76,1.72,2.37,3.84.12.45.24.92.35,1.43A39.28,39.28,0,0,1,266.76,163.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M266.09,155.61l-11-3.38a16.35,16.35,0,0,1,1.45-.87l9.24,2.82C265.86,154.63,266,155.1,266.09,155.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M266.76,163.9c0,.43,0,.86,0,1.31l-19-5.83c.28-.36.57-.72.85-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M266.07,172.26c-.06.42-.13.84-.2,1.26l-22.86-7,.63-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M264.44,180.34c-.11.4-.21.81-.32,1.22L239.5,174l.49-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M261.45,189.65c-.15.39-.3.78-.46,1.18l-25-7.64.41-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M257.75,197.92c-.19.38-.39.76-.59,1.14l-23.82-7.3.35-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M253.57,205.21l-.33.51h0l-.81.45-20.92-6.4a9.35,9.35,0,0,1,.17-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M186.16,201.19s-1.79-4.41-3.53-6.07-33.34-19-47.21-7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M190.11,212.8s1.1-5-5.21-13.39S139,176,133.69,190.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M139.3,202.41c.27.33.55.66.85,1a64.46,64.46,0,0,0,4.94,5.08l.94.86q2.47,2.21,5.4,4.4l1,.74a80.31,80.31,0,0,0,7.16,4.62l1.1.63c2.2,1.22,4.52,2.39,7,3.48l1.18.52c2.13.91,4.35,1.76,6.66,2.53l.57.19h0c.31,0,.61-.09.91-.15,10.51-2.06,15.31-14.27,12.36-18l-.11-.12a10.19,10.19,0,0,0-.92-.89c-1.16-1-3.11-2.49-5.54-4.2l-1-.72c-1.94-1.34-4.14-2.8-6.45-4.26l-1.07-.66c-2.4-1.49-4.91-3-7.38-4.3l-1.12-.59c-2.18-1.15-4.32-2.19-6.33-3l-1.19-.49-1.39-.51a54.26,54.26,0,0,0-5.54-1.62c-.45-.11-.9-.2-1.33-.29a31.25,31.25,0,0,0-8.89-.65c-.59.06-1.15.13-1.68.23-2.9.54-5,1.75-6,3.53-.49.87-.29,2.44.57,4.47.18.43.39.87.63,1.33A38,38,0,0,0,139.3,202.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M134.62,195.54l6.46-9.56c-.59.06-1.15.13-1.68.23l-5.41,8C134.17,194.64,134.38,195.08,134.62,195.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M139.3,202.41c.27.33.55.66.85,1l11.15-16.49c-.45-.11-.9-.2-1.33-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M145.09,208.49l.94.86,13.39-19.81-1.19-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M151.43,213.75l1,.74,14.42-21.33-1.12-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M159.61,219.11l1.1.63,14.61-21.62-1.07-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M167.68,223.22l1.18.52L182.8,203.1l-1-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M175.52,226.27l.57.19h0c.31,0,.61-.09.91-.15l12.25-18.12a10.19,10.19,0,0,0-.92-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M266.09,155.61c-.11-.51-.23-1-.35-1.43-.61-2.12-1.44-3.47-2.37-3.84a5.65,5.65,0,0,0-2.11-.38,8,8,0,0,0-1-.15l0-.05h-.64a9.36,9.36,0,0,0-2.53.33c-4,.85-7.69,3.26-11.06,6.44-.24-2-.71-6.1-1.09-10.08a17.78,17.78,0,0,0-3.16-8.34,10.53,10.53,0,0,0-2.66-2.81s-2.55-9.62-8.56-11.9l-.34-.12-.17-.07h0a13.67,13.67,0,0,0-5.63-.83h0a5,5,0,0,0-1.07.15h0l-.26.06a6.9,6.9,0,0,0-1.28.43h0l-.32.14,0,0,0,0h0l0,0h0l0-.06v0l0-.07v0l0-.09h0a3.63,3.63,0,0,0,.14-.51v0s0-.09,0-.13V122s0-.09,0-.13v-.07s0-.1,0-.15v-.07a.86.86,0,0,0,0-.16v-.08a1.09,1.09,0,0,0,0-.18v0c0-.16,0-.33,0-.52s0-.23,0-.36,0-.44-.09-.69a6.13,6.13,0,0,0,1.56-.57,7,7,0,0,0,2.41-2,2.3,2.3,0,0,0,0-2.78,3.34,3.34,0,0,0-1.88-1.08,15.05,15.05,0,0,0-2.94-.48,20.07,20.07,0,0,0-.25-3c0-.13,0-.26-.07-.39h0a12.46,12.46,0,0,0-.54-2s.59.4,1.57.93l.15.08.05,0,.09,0h0c2.29,1.19,6.3,2.82,10,2a9,9,0,0,0,1-.3,12.08,12.08,0,0,0,1.3-.58,10.34,10.34,0,0,0,4.57-4.5,12.37,12.37,0,0,0,3.59-.13,12,12,0,0,0,5-2.11,1.47,1.47,0,0,0,.7.43h0l.13,0h0l.1,0h.06l.1,0h1.32l.56-.07h0l.3,0h.07l.24-.06.1,0,.24-.06.11,0,.15,0,.12,0h.05l.37-.12c3.82-1.25,4.81-3.59,4.47-5.14a1.31,1.31,0,0,0-.86-.9h0a8.72,8.72,0,0,0-3.7-.14c-1.1.13-1.45-.14-1.07-1a.37.37,0,0,1,.07-.12l1.37-.63a12.16,12.16,0,0,0,2.42-1.46,4.52,4.52,0,0,0,1.22-4.43c-.18-.84-1-1.18-2.07-1.14a6.48,6.48,0,0,0-3.33,1.15c-1.9,1.33-2.73,1.12-3,0-.21-.77,1.2-2.12,2.47-3.41l.09-.09a2,2,0,0,0,1.11-1.19l0,0a1.63,1.63,0,0,0,.17-.2c1.24-1.58-.18-4.11-2.87-4.1a2.07,2.07,0,0,0-.77.14h0c-2,.78-2.16,4.44-3.47,4.18-1.47-.31-.68-1.67.8-3.91.19-.3.39-.61.58-1l.05-.09a.93.93,0,0,0,.34-.65h0a1.3,1.3,0,0,1,.08-.17l0,0,.07-.16,0,0,.07-.16,0,0c.06-.16.13-.32.19-.49l0-.08s0-.07,0-.11l0-.1s0-.07,0-.11l0-.1,0-.1,0-.11,0-.1s0-.07,0-.1l0-.11a.36.36,0,0,1,0-.1s0-.07,0-.1,0-.07,0-.11,0-.06,0-.09l0-.18a.34.34,0,0,1,0-.1s0-.07,0-.11v-.09s0-.07,0-.1v-.19s0-.06,0-.09v-.09a.28.28,0,0,1,0-.09s0-.06,0-.09a.28.28,0,0,0,0-.09.29.29,0,0,0,0-.09.24.24,0,0,0,0-.08.29.29,0,0,0,0-.09s0,0,0-.08l0-.1-.05-.12a.59.59,0,0,0,0-.08.43.43,0,0,0,0-.07.22.22,0,0,0-.05-.08l0-.07-.05-.07a.18.18,0,0,1,0-.07l-.06-.06-.06-.06a.46.46,0,0,0-.07-.07l-.06-.05-.08-.07-.06,0-.1-.06-.06,0-.18-.09a1.87,1.87,0,0,0-1.54,0c-2.2.84-4.8,4.89-5.9,9.47a20.18,20.18,0,0,1-1.06,3.39c-.52,1.15-.88,1.08-1,1a.78.78,0,0,1-.1-.1c-.63-.64-1.82-5.26-2.64-8.18-.14-.48-.28-.93-.43-1.36-.81-2.23-1.9-3.82-3.38-3.91H229l-.18,0h0l-.17.06,0,0-.14.07h0l-.14.1,0,0-.12.11,0,0-.1.12,0,0-.1.15s0,0,0,0l-.09.17,0,0c0,.07-.05.13-.07.2v0a1.46,1.46,0,0,0,0,.2s0,0,0,.06,0,.16,0,.24v.07l0,.26V76c0,.08,0,.17,0,.27v.86c0,.13,0,.26,0,.4a9.78,9.78,0,0,0,.27,1.69c.5,2,1.52,3.66,1.92,6a10.15,10.15,0,0,1,.13,1.93c-.32.12-.66.26-1,.43A10,10,0,0,0,227,88.71h0l-.19.16h0l0,0h0l-.28.26-.09.09a1,1,0,0,0-.18.17l-.14.15-.12.13a1.56,1.56,0,0,0-.16.2l-.06.06-.1.12a12,12,0,0,0-1.18-1.49,10.56,10.56,0,0,0-4.08-2.83c-.16-.4-.34-.78-.53-1.17-.49-3.38-1.4-7.84-2.19-8.43s-1.33-1.28-5.8-.82l-.38-.25a12.87,12.87,0,0,0,.55-1.47c.06-.72.08-1.44.07-2.14a15.79,15.79,0,0,0,3.11-1.27c1.11-.89-2.25-11.82-3.49-11.83-.44,0-2.69.28-3.7.4a18.41,18.41,0,0,0-15.59-7.64L192,50a14.7,14.7,0,0,0-9,2.82l.27.93a17.83,17.83,0,0,0-8.58,15.65c-.88.5-2.88,1.65-3.24,1.91-1,.75,2.86,11.52,4.27,11.57a14.5,14.5,0,0,0,3.18-.82c.33.45.68.88,1.05,1.31-4.08,1.58-6.66,2.89-7.05,3.42-.53.71.28,4.08,1,6.56-1.43.95-3.09,2.91-3.65,7,0,.2-.05.41-.07.62a2.07,2.07,0,0,0-.83.4,2.88,2.88,0,0,0-.68.76,1.28,1.28,0,0,0-.11.2l-.12.24,0,.06a1.55,1.55,0,0,0-.08.23l0,0-.09.3,0,.06-.06.29v.06a2,2,0,0,1,0,.24s0,0,0,.08,0,.22,0,.33h0l0-.05h0l0-.06,0,0,0,0,0,0,0-.06,0,0-.06-.08,0,0-.11-.13,0,0-.09-.1a.38.38,0,0,1-.09-.09l0,0,0,0-.08-.07-.16-.14h0a6.8,6.8,0,0,0-.6-.42h0a7.87,7.87,0,0,0-2-.84c-.75-2.55-1.68-4.8-1.72-7,0-2.36.65-4.19.78-6.23a9.14,9.14,0,0,0-.06-1.72c0-.13,0-.26-.05-.39v-.07l-.06-.34v-.08c0-.11-.05-.21-.07-.31v0c0-.09,0-.18-.07-.26l0-.06a2,2,0,0,0-.08-.26l0-.06-.09-.23,0,0-.09-.19,0,0-.1-.18,0,0a.83.83,0,0,0-.11-.15l0,0-.12-.13,0,0-.12-.1,0,0-.14-.09,0,0-.16-.07h0l-.15,0h0a1.13,1.13,0,0,0-.18,0h-.62l-.09,0h-.08l-.17,0c-1.43.36-2.21,2.13-2.58,4.46-.08.46-.13.93-.18,1.42-.26,3-.57,7.78-1.07,8.53a.7.7,0,0,1-.08.12c-.13.16-.47.29-1.2-.74a19.55,19.55,0,0,1-1.67-3.13c-1.93-4.3-5.24-7.79-7.56-8.21a1.86,1.86,0,0,0-1.51.29l-.16.13-.05,0-.08.09-.06.06-.06.07-.05.07-.06.08a.43.43,0,0,0,0,.07l-.05.07s0,0,0,.08l0,.08a.25.25,0,0,0,0,.07l0,.09s0,0,0,.07l0,.1a.5.5,0,0,0,0,.12.36.36,0,0,0,0,.11s0,0,0,.08,0,.06,0,.09v.26a.28.28,0,0,0,0,.09v.09s0,.06,0,.09a.31.31,0,0,0,0,.1.29.29,0,0,0,0,.09s0,.06,0,.09l0,.1a.29.29,0,0,0,0,.09l0,.1,0,.1a1.09,1.09,0,0,0,.05.17.36.36,0,0,0,0,.09l0,.1a.3.3,0,0,1,0,.1.36.36,0,0,1,0,.09.93.93,0,0,0,.05.1,1,1,0,0,1,0,.1.93.93,0,0,1,.05.1.41.41,0,0,0,0,.09.47.47,0,0,0,.05.1.41.41,0,0,0,.05.09.31.31,0,0,0,0,.1l.05.09.06.11,0,.07c.09.15.18.3.28.44l0,0,.1.14,0,0,.1.14,0,0,.1.15h0a.91.91,0,0,0,.46.57.27.27,0,0,0,.07.08,9.94,9.94,0,0,0,.74.82c1.87,1.93,2.9,3.13,1.52,3.69s-2.13-3-4.2-3.45h0a2,2,0,0,0-.78,0c-2.66.5-3.57,3.25-2.06,4.57l.2.17h0a2.09,2.09,0,0,0,1.32,1l.1.07c1.49,1,3.12,2.09,3.06,2.88-.08,1.11-.84,1.48-3,.52a6.56,6.56,0,0,0-3.48-.51c-1,.16-1.81.65-1.83,1.5a4.51,4.51,0,0,0,2,4.13,11.67,11.67,0,0,0,2.65,1l1.47.36.09.11c.52.75.23,1.09-.87,1.16a8.82,8.82,0,0,0-3.61.82h0a1.29,1.29,0,0,0-.68,1c0,1.58,1.36,3.7,5.35,4.22l.38,0h1.42a4.86,4.86,0,0,0,.56,0h.06l.19,0h.07l.16,0,.07,0,.14,0h.07l.13,0,.07,0,.11,0,.06,0,.11,0,0,0,.1,0,0,0,.09,0h0l.12-.07h0a1.5,1.5,0,0,0,.61-.56,11.76,11.76,0,0,0,4.33,1.12l-.13.18a18.75,18.75,0,0,0,10.79,5.27,13.84,13.84,0,0,0,3.87-.19,14.88,14.88,0,0,0,3-.91s2.71.74,6.53-1.43h0c.35-.2.71-.42,1.08-.67,0,0,.13.61.34,1.28.05.16.1.31.16.47h0l-.07.06-.13.11-.28.24c-.92.82-2.81,2.65-2.62,3.72s1.18,1.59,2.77,1.56c-.14.08-.72.42-1.44.87h0c-1.07.65-2.45,1.53-3.21,2.11l-.06.05h0c-1.3,1-1.85,2.47-4.07,4.18s-2.16,3-3,6.52c-.38,1.55-.78,3.09-1.12,4.34-.44,1.62-.77,2.75-.77,2.75a14,14,0,0,0-1.51,1.74l0,.06,0,0-.06.09,0,0h0a14,14,0,0,0-1,1.56,13.78,13.78,0,0,0-.84,1.9,8.6,8.6,0,0,0-.32,1.16,32.2,32.2,0,0,0-.63,4.54c0,.61-.07,1.17-.08,1.65,0,1.08,0,1.76,0,1.76a12,12,0,0,0-1,1.4h0a15.55,15.55,0,0,0-1.39,2.83,12,12,0,0,0-.73,3.26c-.3,3.76,3.87,14.15,4.9,16.65-8.23-2.41-17.24-3.5-23.74-.22a9.14,9.14,0,0,0-2.18,1.33l-.5.39.05,0a7.41,7.41,0,0,0-.65.72,5.53,5.53,0,0,0-1.4,1.63c-.49.87-.29,2.44.57,4.47.18.43.39.87.63,1.33a38,38,0,0,0,4.68,6.87c.27.33.55.66.85,1a64.46,64.46,0,0,0,4.94,5.08l.94.86q2.47,2.21,5.4,4.4l1,.74a80.31,80.31,0,0,0,7.16,4.62l1.1.63c2.2,1.22,4.52,2.39,7,3.48l1.18.52c2.13.91,4.35,1.76,6.66,2.53l.57.19h0c.31,0,.61-.09.91-.15,7.68-1.5,12.31-8.43,13.1-13.51,0,0,0-.11,0-.33a6.72,6.72,0,0,0-.31-3.34,24.31,24.31,0,0,0-3.68-7.94A32.38,32.38,0,0,0,184,196.9a87.29,87.29,0,0,0-.13-10.55c-.52-5.34-2.23-9.49-2-12.35,0,0,2.55-1.18,4.64-10,.26-1.09.51-2.3.75-3.64l.19-.06c1.1-.35,6.73-2.37,8.95-7.36,2.47-5.54,4.94-6.34,6.26-5.49s6.91,6.17,15.1,5.77c0,0,.23.53.68,1.35h0a26,26,0,0,0,2.07,3.21,15,15,0,0,0,5.14,4.55,54.55,54.55,0,0,1,.77,11.32c-.12,5.12.46,11.45,2.24,15.31.33,1.82.81,3.43.81,3.43a24.65,24.65,0,0,0,2.13,8.5,6.79,6.79,0,0,0,1.86,2.79,2.92,2.92,0,0,0,.24.22c3.8,3.46,11.76,6,18.68,2.29l.81-.45h0l.33-.51c1.31-2.05,2.5-4.11,3.59-6.15.2-.38.4-.76.59-1.14,1.22-2.39,2.29-4.76,3.24-7.09.16-.4.31-.79.46-1.18a83.87,83.87,0,0,0,2.67-8.09c.11-.41.21-.82.32-1.22.6-2.36,1.08-4.64,1.43-6.82.07-.42.14-.84.2-1.26a64.74,64.74,0,0,0,.66-7c0-.45,0-.88,0-1.31A39.28,39.28,0,0,0,266.09,155.61ZM163,149.05h0v0Zm15.42-24.12-.19,0a1.13,1.13,0,0,1-.41-.16.52.52,0,0,1-.16-.17l0-.09a.59.59,0,0,1,0-.23,2,2,0,0,1,.24-.8c0-.09.1-.19.16-.28s.25-.38.38-.55l.09-.13.19-.23c.28-.34.5-.56.5-.56A13.75,13.75,0,0,0,178.43,124.93Zm42.38-9.5h0s3.39-.59,3.92.16c.37.55.13,1.38-1.23,1.88a7,7,0,0,1-2,.4c-.17-.65-.39-1.36-.68-2.16A2.21,2.21,0,0,0,220.81,115.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M266.09,155.61c-.11-.51-.23-1-.35-1.43-.61-2.12-1.44-3.47-2.37-3.84a5.65,5.65,0,0,0-2.11-.38,8,8,0,0,0-1-.15l0-.05h-.64a9.36,9.36,0,0,0-2.53.33c-4,.85-7.69,3.26-11.06,6.44-.24-2-.71-6.1-1.09-10.08a17.78,17.78,0,0,0-3.16-8.34,10.53,10.53,0,0,0-2.66-2.81s-2.55-9.62-8.56-11.9l-.34-.12-.17-.07h0a13.67,13.67,0,0,0-5.63-.83h0a5,5,0,0,0-1.07.15h0l-.26.06a6.9,6.9,0,0,0-1.28.43h0l-.32.14,0,0,0,0h0l0,0h0l0-.06v0l0-.07v0l0-.09h0a3.63,3.63,0,0,0,.14-.51v0s0-.09,0-.13V122s0-.09,0-.13v-.07s0-.1,0-.15v-.07a.86.86,0,0,0,0-.16v-.08a1.09,1.09,0,0,0,0-.18v0c0-.16,0-.33,0-.52s0-.23,0-.36,0-.44-.09-.69a6.13,6.13,0,0,0,1.56-.57,7,7,0,0,0,2.41-2,2.3,2.3,0,0,0,0-2.78,3.34,3.34,0,0,0-1.88-1.08,15.05,15.05,0,0,0-2.94-.48,20.07,20.07,0,0,0-.25-3c0-.13,0-.26-.07-.39h0a12.46,12.46,0,0,0-.54-2s.59.4,1.57.93l.15.08.05,0,.09,0h0c2.29,1.19,6.3,2.82,10,2a9,9,0,0,0,1-.3,12.08,12.08,0,0,0,1.3-.58,10.34,10.34,0,0,0,4.57-4.5,12.37,12.37,0,0,0,3.59-.13,12,12,0,0,0,5-2.11,1.47,1.47,0,0,0,.7.43h0l.13,0h0l.1,0h.06l.1,0h1.32l.56-.07h0l.3,0h.07l.24-.06.1,0,.24-.06.11,0,.15,0,.12,0h.05l.37-.12c3.82-1.25,4.81-3.59,4.47-5.14a1.31,1.31,0,0,0-.86-.9h0a8.72,8.72,0,0,0-3.7-.14c-1.1.13-1.45-.14-1.07-1a.37.37,0,0,1,.07-.12l1.37-.63a12.16,12.16,0,0,0,2.42-1.46,4.52,4.52,0,0,0,1.22-4.43c-.18-.84-1-1.18-2.07-1.14a6.48,6.48,0,0,0-3.33,1.15c-1.9,1.33-2.73,1.12-3,0-.21-.77,1.2-2.12,2.47-3.41l.09-.09a2,2,0,0,0,1.11-1.19l0,0a1.63,1.63,0,0,0,.17-.2c1.24-1.58-.18-4.11-2.87-4.1a2.07,2.07,0,0,0-.77.14h0c-2,.78-2.16,4.44-3.47,4.18-1.47-.31-.68-1.67.8-3.91.19-.3.39-.61.58-1l.05-.09a.93.93,0,0,0,.34-.65h0a1.3,1.3,0,0,1,.08-.17l0,0,.07-.16,0,0,.07-.16,0,0c.06-.16.13-.32.19-.49l0-.08s0-.07,0-.11l0-.1s0-.07,0-.11l0-.1,0-.1,0-.11,0-.1s0-.07,0-.1l0-.11a.36.36,0,0,1,0-.1s0-.07,0-.1,0-.07,0-.11,0-.06,0-.09l0-.18a.34.34,0,0,1,0-.1s0-.07,0-.11v-.09s0-.07,0-.1v-.19s0-.06,0-.09v-.09a.28.28,0,0,1,0-.09s0-.06,0-.09a.28.28,0,0,0,0-.09.29.29,0,0,0,0-.09.24.24,0,0,0,0-.08.29.29,0,0,0,0-.09s0,0,0-.08l0-.1-.05-.12a.59.59,0,0,0,0-.08.43.43,0,0,0,0-.07.22.22,0,0,0-.05-.08l0-.07-.05-.07a.18.18,0,0,1,0-.07l-.06-.06-.06-.06a.46.46,0,0,0-.07-.07l-.06-.05-.08-.07-.06,0-.1-.06-.06,0-.18-.09a1.87,1.87,0,0,0-1.54,0c-2.2.84-4.8,4.89-5.9,9.47a20.18,20.18,0,0,1-1.06,3.39c-.52,1.15-.88,1.08-1,1a.78.78,0,0,1-.1-.1c-.63-.64-1.82-5.26-2.64-8.18-.14-.48-.28-.93-.43-1.36-.81-2.23-1.9-3.82-3.38-3.91H229l-.18,0h0l-.17.06,0,0-.14.07h0l-.14.1,0,0-.12.11,0,0-.1.12,0,0-.1.15s0,0,0,0l-.09.17,0,0c0,.07-.05.13-.07.2v0a1.46,1.46,0,0,0,0,.2s0,0,0,.06,0,.16,0,.24v.07l0,.26V76c0,.08,0,.17,0,.27v.86c0,.13,0,.26,0,.4a9.78,9.78,0,0,0,.27,1.69c.5,2,1.52,3.66,1.92,6a10.15,10.15,0,0,1,.13,1.93c-.32.12-.66.26-1,.43A10,10,0,0,0,227,88.71h0l-.19.16h0l0,0h0l-.28.26-.09.09a1,1,0,0,0-.18.17l-.14.15-.12.13a1.56,1.56,0,0,0-.16.2l-.06.06-.1.12a12,12,0,0,0-1.18-1.49,10.56,10.56,0,0,0-4.08-2.83c-.16-.4-.34-.78-.53-1.17-.49-3.38-1.4-7.84-2.19-8.43s-1.33-1.28-5.8-.82l-.38-.25a12.87,12.87,0,0,0,.55-1.47c.06-.72.08-1.44.07-2.14a15.79,15.79,0,0,0,3.11-1.27c1.11-.89-2.25-11.82-3.49-11.83-.44,0-2.69.28-3.7.4a18.41,18.41,0,0,0-15.59-7.64L192,50a14.7,14.7,0,0,0-9,2.82l.27.93a17.83,17.83,0,0,0-8.58,15.65c-.88.5-2.88,1.65-3.24,1.91-1,.75,2.86,11.52,4.27,11.57a14.5,14.5,0,0,0,3.18-.82c.33.45.68.88,1.05,1.31-4.08,1.58-6.66,2.89-7.05,3.42-.53.71.28,4.08,1,6.56-1.43.95-3.09,2.91-3.65,7,0,.2-.05.41-.07.62a2.07,2.07,0,0,0-.83.4,2.88,2.88,0,0,0-.68.76,1.28,1.28,0,0,0-.11.2l-.12.24,0,.06a1.55,1.55,0,0,0-.08.23l0,0-.09.3,0,.06-.06.29v.06a2,2,0,0,1,0,.24s0,0,0,.08,0,.22,0,.33h0l0-.05h0l0-.06,0,0,0,0,0,0,0-.06,0,0-.06-.08,0,0-.11-.13,0,0-.09-.1a.38.38,0,0,1-.09-.09l0,0,0,0-.08-.07-.16-.14h0a6.8,6.8,0,0,0-.6-.42h0a7.87,7.87,0,0,0-2-.84c-.75-2.55-1.68-4.8-1.72-7,0-2.36.65-4.19.78-6.23a9.14,9.14,0,0,0-.06-1.72c0-.13,0-.26-.05-.39v-.07l-.06-.34v-.08c0-.11-.05-.21-.07-.31v0c0-.09,0-.18-.07-.26l0-.06a2,2,0,0,0-.08-.26l0-.06-.09-.23,0,0-.09-.19,0,0-.1-.18,0,0a.83.83,0,0,0-.11-.15l0,0-.12-.13,0,0-.12-.1,0,0-.14-.09,0,0-.16-.07h0l-.15,0h0a1.13,1.13,0,0,0-.18,0h-.62l-.09,0h-.08l-.17,0c-1.43.36-2.21,2.13-2.58,4.46-.08.46-.13.93-.18,1.42-.26,3-.57,7.78-1.07,8.53a.7.7,0,0,1-.08.12c-.13.16-.47.29-1.2-.74a19.55,19.55,0,0,1-1.67-3.13c-1.93-4.3-5.24-7.79-7.56-8.21a1.86,1.86,0,0,0-1.51.29l-.16.13-.05,0-.08.09-.06.06-.06.07-.05.07-.06.08a.43.43,0,0,0,0,.07l-.05.07s0,0,0,.08l0,.08a.25.25,0,0,0,0,.07l0,.09s0,0,0,.07l0,.1a.5.5,0,0,0,0,.12.36.36,0,0,0,0,.11s0,0,0,.08,0,.06,0,.09v.26a.28.28,0,0,0,0,.09v.09s0,.06,0,.09a.31.31,0,0,0,0,.1.29.29,0,0,0,0,.09s0,.06,0,.09l0,.1a.29.29,0,0,0,0,.09l0,.1,0,.1a1.09,1.09,0,0,0,.05.17.36.36,0,0,0,0,.09l0,.1a.3.3,0,0,1,0,.1.36.36,0,0,1,0,.09.93.93,0,0,0,.05.1,1,1,0,0,1,0,.1.93.93,0,0,1,.05.1.41.41,0,0,0,0,.09.47.47,0,0,0,.05.1.41.41,0,0,0,.05.09.31.31,0,0,0,0,.1l.05.09.06.11,0,.07c.09.15.18.3.28.44l0,0,.1.14,0,0,.1.14,0,0,.1.15h0a.91.91,0,0,0,.46.57.27.27,0,0,0,.07.08,9.94,9.94,0,0,0,.74.82c1.87,1.93,2.9,3.13,1.52,3.69s-2.13-3-4.2-3.45h0a2,2,0,0,0-.78,0c-2.66.5-3.57,3.25-2.06,4.57l.2.17h0a2.09,2.09,0,0,0,1.32,1l.1.07c1.49,1,3.12,2.09,3.06,2.88-.08,1.11-.84,1.48-3,.52a6.56,6.56,0,0,0-3.48-.51c-1,.16-1.81.65-1.83,1.5a4.51,4.51,0,0,0,2,4.13,11.67,11.67,0,0,0,2.65,1l1.47.36.09.11c.52.75.23,1.09-.87,1.16a8.82,8.82,0,0,0-3.61.82h0a1.29,1.29,0,0,0-.68,1c0,1.58,1.36,3.7,5.35,4.22l.38,0h1.42a4.86,4.86,0,0,0,.56,0h.06l.19,0h.07l.16,0,.07,0,.14,0h.07l.13,0,.07,0,.11,0,.06,0,.11,0,0,0,.1,0,0,0,.09,0h0l.12-.07h0a1.5,1.5,0,0,0,.61-.56,11.76,11.76,0,0,0,4.33,1.12l-.13.18a18.75,18.75,0,0,0,10.79,5.27,13.84,13.84,0,0,0,3.87-.19,14.88,14.88,0,0,0,3-.91s2.71.74,6.53-1.43h0c.35-.2.71-.42,1.08-.67,0,0,.13.61.34,1.28.05.16.1.31.16.47h0l-.07.06-.13.11-.28.24c-.92.82-2.81,2.65-2.62,3.72s1.18,1.59,2.77,1.56c-.14.08-.72.42-1.44.87h0c-1.07.65-2.45,1.53-3.21,2.11l-.06.05h0c-1.3,1-1.85,2.47-4.07,4.18s-2.16,3-3,6.52c-.38,1.55-.78,3.09-1.12,4.34-.44,1.62-.77,2.75-.77,2.75a14,14,0,0,0-1.51,1.74l0,.06,0,0-.06.09,0,0h0a14,14,0,0,0-1,1.56,13.78,13.78,0,0,0-.84,1.9,8.6,8.6,0,0,0-.32,1.16,32.2,32.2,0,0,0-.63,4.54c0,.61-.07,1.17-.08,1.65,0,1.08,0,1.76,0,1.76a12,12,0,0,0-1,1.4h0a15.55,15.55,0,0,0-1.39,2.83,12,12,0,0,0-.73,3.26c-.3,3.76,3.87,14.15,4.9,16.65-8.23-2.41-17.24-3.5-23.74-.22a9.14,9.14,0,0,0-2.18,1.33l-.5.39.05,0a7.41,7.41,0,0,0-.65.72,5.53,5.53,0,0,0-1.4,1.63c-.49.87-.29,2.44.57,4.47.18.43.39.87.63,1.33a38,38,0,0,0,4.68,6.87c.27.33.55.66.85,1a64.46,64.46,0,0,0,4.94,5.08l.94.86q2.47,2.21,5.4,4.4l1,.74a80.31,80.31,0,0,0,7.16,4.62l1.1.63c2.2,1.22,4.52,2.39,7,3.48l1.18.52c2.13.91,4.35,1.76,6.66,2.53l.57.19h0c.31,0,.61-.09.91-.15,7.68-1.5,12.31-8.43,13.1-13.51,0,0,0-.11,0-.33a6.72,6.72,0,0,0-.31-3.34,24.31,24.31,0,0,0-3.68-7.94A32.38,32.38,0,0,0,184,196.9a87.29,87.29,0,0,0-.13-10.55c-.52-5.34-2.23-9.49-2-12.35,0,0,2.55-1.18,4.64-10,.26-1.09.51-2.3.75-3.64l.19-.06c1.1-.35,6.73-2.37,8.95-7.36,2.47-5.54,4.94-6.34,6.26-5.49s6.91,6.17,15.1,5.77c0,0,.23.53.68,1.35h0a26,26,0,0,0,2.07,3.21,15,15,0,0,0,5.14,4.55,54.55,54.55,0,0,1,.77,11.32c-.12,5.12.46,11.45,2.24,15.31.33,1.82.81,3.43.81,3.43a24.65,24.65,0,0,0,2.13,8.5,6.79,6.79,0,0,0,1.86,2.79,2.92,2.92,0,0,0,.24.22c3.8,3.46,11.76,6,18.68,2.29l.81-.45h0l.33-.51c1.31-2.05,2.5-4.11,3.59-6.15.2-.38.4-.76.59-1.14,1.22-2.39,2.29-4.76,3.24-7.09.16-.4.31-.79.46-1.18a83.87,83.87,0,0,0,2.67-8.09c.11-.41.21-.82.32-1.22.6-2.36,1.08-4.64,1.43-6.82.07-.42.14-.84.2-1.26a64.74,64.74,0,0,0,.66-7c0-.45,0-.88,0-1.31A39.28,39.28,0,0,0,266.09,155.61ZM163,149.05h0v0Zm15.42-24.12-.19,0a1.13,1.13,0,0,1-.41-.16.52.52,0,0,1-.16-.17l0-.09a.59.59,0,0,1,0-.23,2,2,0,0,1,.24-.8c0-.09.1-.19.16-.28s.25-.38.38-.55l.09-.13.19-.23c.28-.34.5-.56.5-.56A13.75,13.75,0,0,0,178.43,124.93Zm42.38-9.5h0s3.39-.59,3.92.16c.37.55.13,1.38-1.23,1.88a7,7,0,0,1-2,.4c-.17-.65-.39-1.36-.68-2.16A2.21,2.21,0,0,0,220.81,115.43Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError500);
export default __webpack_public_path__ + "static/media/error500.342ea542f1d3642bbdbf25460f208c73.svg";
export { ForwardRef as ReactComponent };